export default __webpack_public_path__ + "static/logo-on-gradient-960451dbdeaf65a3f4591c911b472188.png";